import { ChatMessageType } from "../contracts";

export const getChatMessageTypeLabel = (type: ChatMessageType): string => {
    switch (type) {
        case ChatMessageType.User:
            return "User";
        case ChatMessageType.Assistant:
            return "Assistant";
        case ChatMessageType.ToolRequest:
            return "Tool Request";
        case ChatMessageType.ToolResponse:
            return "Tool Response";
        case ChatMessageType.AgentRequest:
            return "Agent Request";
        case ChatMessageType.AgentResponse:
            return "Agent Response";
        default:
            return "Unknown";
    }
};
